import { Link } from '@tanstack/react-router';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { usePermissions } from '@/hooks/use-permissions';
import { PERMISSIONS } from '@property/shared';

export function AddPropertyButton() {
  const { can } = usePermissions();

  if (!can(PERMISSIONS.PROPERTIES_CREATE)) {
    return null;
  }

  return (
    <Link to="/dashboard/land-monitoring/add-property">
      <Button className="bg-primary hover:bg-primary/90 shadow-lg shadow-primary/20 h-10 px-6 font-semibold transition-all hover:scale-105 active:scale-95">
        <Plus className="mr-2 h-4 w-4" />
        Add Property
      </Button>
    </Link>
  );
}
